import React from "react";
import { ClerkProvider } from "@clerk/react-router";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import App from "./App";
import { ErrorBoundary } from "./components/application/error-boundary/ErrorBoundary";
import { setupGlobalErrorHandlers } from "./services/error-logging-service";
import "./styles/globals.css";

// Set up global error handlers for uncaught errors and unhandled rejections
setupGlobalErrorHandlers();

// Create a data router - required for useBlocker and other modern React Router features
const router = createBrowserRouter([
    {
        path: "*",
        element: (
            <ClerkProvider publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}>
                <App />
            </ClerkProvider>
        ),
    },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <ErrorBoundary>
            <RouterProvider router={router} />
        </ErrorBoundary>
    </React.StrictMode>,
);
